import type { ReactElement } from 'react'

import { Chip } from '@mui/material'

import { actionButtonStyle } from '../styles'

const SidebarButton = ({
  label,
  icon,
  onClick,
  disabled = false,
  sx = null,
  flat = false,
  className = '',
}: {
  label: string
  icon: ReactElement
  onClick: (e?: any) => void
  disabled?: boolean
  sx?: any
  flat?: boolean
  className?: string
}) => {
  const flatSx = flat ? { boxShadow: 'none' } : {}
  return (
    <Chip
      variant="outlined"
      size="small"
      disabled={disabled}
      label={label}
      icon={icon}
      onClick={onClick}
      sx={{
        ...actionButtonStyle,
        ...flatSx,
        ...(sx || {}),
      }}
      className={className}
    />
  )
}

export default SidebarButton
